import { render, staticRenderFns } from "./Sellinone.vue?vue&type=template&id=12797cf4&scoped=true&"
import script from "./Sellinone.vue?vue&type=script&lang=js&"
export * from "./Sellinone.vue?vue&type=script&lang=js&"
import style0 from "./Sellinone.vue?vue&type=style&index=0&id=12797cf4&scoped=true&lang=css&"
import style1 from "./Sellinone.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12797cf4",
  null
  
)

export default component.exports